import { bonusesAvailableRoutes, CLIENT_PROFILE_COMPONENT_TYPES } from '@atlas/routing';

const { BONUSES_BONUS_HISTORY, BONUSES_DEPOSIT, BONUSES_FREEBET, BONUSES_FREESPINS } =
  CLIENT_PROFILE_COMPONENT_TYPES;

// The combined feed (FT-8143) owns the parent /bonuses path, so BONUSES_DEPOSIT.link is empty.
// Freebets, freespins, and history keep their original routing-lib segments - only the URL for the combined list (and the universal /bonuses/{id} detail) needs to change for FT-8194 /
// FT-8145 to coexist
export const COMBINED_BONUSES_SEGMENT = '';
export const BONUSES_FREEBETS_SEGMENT =
  bonusesAvailableRoutes[BONUSES_FREEBET]?.link || 'bonuses-freebet';
export const BONUSES_FREESPINS_SEGMENT =
  bonusesAvailableRoutes[BONUSES_FREESPINS]?.link || 'bonuses-freespins';
export const BONUSES_HISTORY_SEGMENT =
  bonusesAvailableRoutes[BONUSES_BONUS_HISTORY]?.link || 'bonuses-history';

// Legacy segments preserved only as redirect sources (bookmarks, CRM, external links)
export const LEGACY_BONUSES_DEPOSIT_SEGMENT =
  bonusesAvailableRoutes[BONUSES_DEPOSIT]?.link || 'bonuses-deposit';

const bonusesTabRoutes = {
  ...bonusesAvailableRoutes,
  [BONUSES_DEPOSIT]: {
    ...bonusesAvailableRoutes[BONUSES_DEPOSIT],
    link: COMBINED_BONUSES_SEGMENT,
  },
};

export default bonusesTabRoutes;
